import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertDate'
})
export class ConvertDatePipe implements PipeTransform {
  timeSince(date) {
    let seconds = Math.floor((<any>new Date() - date) / 1000) + 60;
    let interval = seconds / 31536000;
    if (interval > 1) {
      return Math.floor(interval) + " năm trước";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " tháng trước";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " ngày trước";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " giờ trước";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " phút trước";
    }
    return Math.floor(seconds) + " giây trước";
  }
  transform(dateTime: any, isShowSinceDate?: boolean): any {
    if(dateTime) {
      const days = ['CN', 'Th 2', 'Th 3', 'Th 4', 'Th 5', 'Th 6', 'Th 7'];
      const time = new Date(dateTime);
      let date = ("0" + time.getDate()).slice(-2);
      let month = ("0" + (time.getMonth() + 1)).slice(-2);
      let year = time.getFullYear();
      let dayName = days[time.getDay()];
      let hours = time.getHours();
      let minutes = time.getMinutes();
      let minutesString = '';
      if(minutes <= 9){
        minutesString = 0 +''+ minutes;
      }else{
        minutesString = minutes+'';
      }
      let sinceDate = '';
      if(isShowSinceDate){
        sinceDate = ' ('+this.timeSince(new Date(dateTime))+')';
      }
      return hours + ':' + minutesString + ', '+ dayName +', ' + date + " Thg " + month + ", " + year + sinceDate;
    }
  }

}
